// Condensed-affiliate product line selection. Remove this file (and its snippet/CSS
// plus bb-funnel-v2 hooks) when the condensed-affiliate test ends.
window.SubscriptionFunnel.CondensedProductLine = {
  PRODUCT_LINE_TO_BRAND: {
    barkbox: "BARKBOX",
    superchewer: "SUPERCHEWER",
    barkboxcombo: "BARKBOXCOMBO",
    alltreats: "ALLTREATS",
  },

  BRAND_TO_PRODUCT_LINE: {
    BARKBOX: "barkbox",
    SUPERCHEWER: "superchewer",
    BARKBOXCOMBO: "barkboxcombo",
    ALLTREATS: "alltreats",
  },

  getBrandForProductLine(productLine) {
    return this.PRODUCT_LINE_TO_BRAND[productLine] || null;
  },

  isLovePlanVariant(variant, brand) {
    const promoType = SubscriptionFunnel.FunnelUtilities.promo_type;
    const assortment = variant.assortment;

    if (brand === "ALLTREATS") {
      if (
        assortment ===
        "2 Jerky, 2 Soft Chews, 1 Biscuit, 1 Collagen Chew, 1 Iced Cookie"
      ) {
        return true;
      }

      if (
        promoType === "FEXC" &&
        assortment ===
          "2 Jerky, 2 Soft Chews, 1 Biscuit, 1 Collagen Chew, 1 Iced Cookie + FREE Extra Treats"
      ) {
        return true;
      }

      return false;
    }

    if (assortment === "Love: 2 Toys, 2 Treats, 1 Chew - Allergy Free") {
      return true;
    }

    if (
      promoType === "FEXT" &&
      assortment ===
        "Love + FREE Extra Toys: 3 Toys, 2 Treats, 1 Chew - Allergy Free"
    ) {
      return true;
    }

    if (
      promoType === "FEXC" &&
      assortment ===
        "Love + FREE Extra Treats: 2 Toys, 3 Treats, 1 Chew - Allergy Free"
    ) {
      return true;
    }

    return false;
  },

  getPlanPricing(productLine) {
    const brand = this.getBrandForProductLine(productLine);
    if (!brand || typeof variantsData === "undefined") {
      return {};
    }

    const pricing = {};

    variantsData.forEach((variant) => {
      if (
        variant.productLine !== brand ||
        !this.isLovePlanVariant(variant, brand)
      ) {
        return;
      }

      const length = Number(variant.commitmentLength);
      if (![1, 6, 12].includes(length) || pricing[length]) {
        return;
      }

      pricing[length] = {
        display: variant.priceDisplay,
        cents: variant.price,
      };
    });

    return pricing;
  },

  updatePlanPricingDisplay(productLine) {
    const pricing = this.getPlanPricing(productLine);
    const planConfigs = [
      { length: 1, id: "condensed-plan-1" },
      { length: 6, id: "condensed-plan-6" },
      { length: 12, id: "condensed-plan-12" },
    ];

    planConfigs.forEach(({ length, id }) => {
      const radio = document.getElementById(id);
      if (!radio) return;

      const wrapper = radio.closest(".radio-decoy-component-button-wrapper");
      const label = document.querySelector(`label[for="${id}"]`);
      const priceInfo = pricing[length];

      if (priceInfo && label) {
        radio.dataset.monthlyPrice = String(priceInfo.cents);
        label.textContent = ` ${length} month${length === 1 ? "" : "s"} - ${priceInfo.display} `;
        wrapper?.classList.remove("display-none");
      } else {
        wrapper?.classList.add("display-none");
        if (radio.checked) {
          radio.checked = false;
        }
      }
    });

    const condensed = SubscriptionFunnel.StepCondensed;
    condensed?.updatePrepaidSectionVisibility?.();
    condensed?.updatePrepaidPrice?.();
  },

  handleProductLineChange(productLine) {
    quizData.productLine = productLine;
    this.updatePlanPricingDisplay(productLine);
    this.sendProductLineSelectionEvent(productLine);
  },

  sendProductLineSelectionEvent(productLine) {
    Shopify.analytics.publish("rudderstack_track", {
      eventName: "Product Line Selected",
      eventData: {
        "Selected Product Line": productLine,
        brand: SubscriptionFunnel.FunnelUtilities.subscription_type,
        promo: SubscriptionFunnel.FunnelUtilities.promo_type,
        "Play Subscription Collection Name":
          SubscriptionFunnel.FunnelUtilities.collection_name,
        subscriberType: window.subscriberType,
        funnelTest: SubscriptionFunnel.FunnelUtilities.funnel_test,
        selectionContext: "condensed-affiliate",
      },
    });
  },

  getDefaultProductLine() {
    return (
      this.BRAND_TO_PRODUCT_LINE[
        SubscriptionFunnel.FunnelUtilities.subscription_type
      ] || "barkbox"
    );
  },

  resolveAvailableProductLine(preferredLine) {
    const preferredRadio = document.querySelector(
      `input[name="condensedProductLine"][value="${preferredLine}"]`
    );
    if (preferredRadio) {
      return preferredLine;
    }

    const checkedRadio = document.querySelector(
      'input[name="condensedProductLine"]:checked'
    );
    if (checkedRadio) {
      return checkedRadio.value;
    }

    const firstRadio = document.querySelector(
      'input[name="condensedProductLine"]'
    );
    return firstRadio?.value || this.getDefaultProductLine();
  },

  syncFromQuizData() {
    const preferredLine = quizData.productLine || this.getDefaultProductLine();
    const productLine = this.resolveAvailableProductLine(preferredLine);

    quizData.productLine = productLine;

    document
      .querySelectorAll('input[name="condensedProductLine"]')
      .forEach((radio) => {
        radio.checked = radio.value === productLine;
      });

    this.updatePlanPricingDisplay(productLine);
  },

  init() {
    if (!SubscriptionFunnel.StepCondensed?.isCondensedAffiliateTest?.()) {
      return;
    }

    this.syncFromQuizData();
  },
};
